<template>
  <div>
    <div class="serchBox">
      <!-- <div class="logoImg img">
        <img
          src="../../assets/img/logo-p.png"
          alt=""
          srcset=""
        />
      </div> -->
      <div class="inpBox">
        <div class="inp">
          <div class="search">
            <div class="iconfont icon-search"></div>
          </div>
          <div class="shu"></div>
          <input
            type="text"
            placeholder="请输入关键词搜索"
            v-model="searChTxt"
            @keyup.enter="searchClick"
            name=""
            id=""
          />
          <div class="searchBtn" @click="searchClick">搜索</div>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="leftCont">
        <div class="chengzhihao">
          <div
            class="text"
            :class="index == typeOn ? 'on' : ''"
            v-for="(item, index) in typeList"
            @click="typeClick(index)"
          >
            {{ item }}
          </div>
        </div>
        <div class="pzBox pzBoxh">
          <div class="pzCnt">
            <div class="name">工作区域:</div>
            <div class="boxs">
              <div
                class="box"
                :class="item.id == areaOn ? 'on' : ''"
                v-for="item in areaList"
                @click="areaClick(item.id)"
              >
                {{ item.name }}
              </div>
            </div>
          </div>
          <div class="pzCnt">
            <div class="name">零工工种:</div>
            <div class="boxs">
              <div
                class="box"
                :class="item.id == gzTypeOn ? 'on' : ''"
                v-for="item in gzTypeList"
                @click="gzTypeClick(item.id)"
              >
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>
        <div class="sxCont">
          <div
            class="text"
            :class="item.type == sxTypeOn ? 'on' : ''"
            v-for="item in sxTypeList"
            @click="sxTypeClick(item.type)"
          >
            {{ item.name }}
          </div>
        </div>
        <div class="lgBox" v-if="typeOn == 0">
          <Kong v-if="list.length == 0" />
          <div class="cont" v-for="item in list" @click="gZjump(item.id)">
            <div class="titBox">
              <div class="name">{{ item.name }}</div>
              <div class="address">{{ item.district_cn }}</div>
            </div>
            <div class="moneyBox">
              <div class="name">
                {{ item.price }} 元/{{
                  item.way == 1
                    ? "件"
                    : item.way == 2
                    ? "小时"
                    : item.way == 3
                    ? "天"
                    : "小时"
                }}
              </div>
              <div class="text">
                {{
                  item.result == 1 ? "日结" : item.result == 2 ? "周结" : "月结"
                }}
              </div>
            </div>
            <div class="textBox">
              <div class="text">工 种：{{ item.linggong }}</div>
              <div class="text">发布时间：{{ item.create_time }}</div>
            </div>
            <div class="textBox">
              <div class="txt">公司名称：{{ item.companyname }}</div>
            </div>
          </div>
          <div class="fenye" v-if="totalCount > 10">
            <a-pagination
              :default-current="page.pageNo"
              v-model="page.pageNo"
              :total="totalCount"
              :page-size="10"
              @change="pageOnChange"
            />
          </div>
        </div>
        <div class="list" v-if="typeOn == 1">
          <div
            class="li"
            v-for="item in sfList"
            @click="sFjump(item.member_id)"
          >
            <div class="img">
              <img :src="$imgUrl + item.avatars" alt="" />
            </div>
            <div class="cont">
              <div class="titleBox">
                <div class="name">{{ item.realname }}</div>
                <div class="star">
                  <div
                    class="iconfont icon-collection_fill"
                    v-for="item in item.star"
                  ></div>
                </div>
              </div>
              <div class="box">
                <div class="wzList">
                  <div class="wzLi disc">
                    <div class="name">擅长服务:</div>
                    <div class="wzBox">
                      <div class="txt" v-for="chi in item.config_cn">
                        {{ chi }}
                      </div>
                    </div>
                  </div>
                  <div class="wzLi">
                    <div class="name">服务区域:</div>
                    <div class="texts">
                      {{ item.ling_district_cn }}
                    </div>
                  </div>
                  <div class="wzLi">
                    <div class="name">个人介绍:</div>
                    <div class="texts">
                      {{ item.ling_content }}
                    </div>
                  </div>
                </div>
                <div class="fwBox">
                  <div class="text">综合服务分</div>
                  <div class="name">{{ item.evaluatelength }}</div>
                </div>
                <div class="fwBox">
                  <div class="text">累计服务次数</div>
                  <div class="name">{{ item.orderlength }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="fenye" v-if="sfTotalCount > 10">
            <a-pagination
              :default-current="sfPage.pageNo"
              v-model="sfPage.pageNo"
              :total="sfTotalCount"
              :page-size="10"
              @change="sfPageOnChange"
            />
          </div>
        </div>
      </div>
      <div class="rightCont">
        <LoginZj />
        <div class="cont">
          <div class="contHead">
            <div class="name">找师傅 请放心</div>
          </div>
          <div class="contList">
            <div class="li">
              每一位师傅都经过层层考核筛选，每年 200+场专业培训全国开展
            </div>
            <div class="li">提供全方位权益保障，专业保险保驾护航</div>
            <div class="li">提供全程交易担保，服务满意 才交付费用</div>
          </div>
        </div>
        <!-- <div class="cont">
          <div class="contHead">
            <div class="name">匠心师傅推荐</div>
          </div>
          <div class="renList">
            <div class="renLi">
              <div class="img">
                <img
                  src="https://t7.baidu.com/it/u=2711282081,3613356898&fm=3031&app=3031&size=f242,150&n=0&f=JPEG&fmt=auto?s=B70B9D4FCE32449ECAB3347A03008018&sec=1722790800&t=6ebd99033fa0f146d4fdecb1400b737b"
                  alt=""
                />
              </div>
              <div class="box">
                <div class="titleBox">
                  <div class="name">林师傅</div>
                  <div class="star">
                    <div class="iconfont icon-collection_fill"></div>
                    <div class="iconfont icon-collection_fill"></div>
                    <div class="iconfont icon-collection_fill"></div>
                    <div class="iconfont icon-collection_fill"></div>
                  </div>
                </div>
                <div class="textBox">
                  <div class="text">服务类型：安装，维修</div>
                  <div class="text">累计服务：2501次</div>
                </div>
              </div>
            </div>
            <div class="renLi">
              <div class="img">
                <img
                  src="https://t7.baidu.com/it/u=2711282081,3613356898&fm=3031&app=3031&size=f242,150&n=0&f=JPEG&fmt=auto?s=B70B9D4FCE32449ECAB3347A03008018&sec=1722790800&t=6ebd99033fa0f146d4fdecb1400b737b"
                  alt=""
                />
              </div>
              <div class="box">
                <div class="titleBox">
                  <div class="name">林师傅</div>
                  <div class="star">
                    <div class="iconfont icon-collection_fill"></div>
                    <div class="iconfont icon-collection_fill"></div>
                    <div class="iconfont icon-collection_fill"></div>
                    <div class="iconfont icon-collection_fill"></div>
                  </div>
                </div>
                <div class="textBox">
                  <div class="text">服务类型：安装，维修</div>
                  <div class="text">累计服务：2501次</div>
                </div>
              </div>
            </div>
            <div class="renLi">
              <div class="img">
                <img
                  src="https://t7.baidu.com/it/u=2711282081,3613356898&fm=3031&app=3031&size=f242,150&n=0&f=JPEG&fmt=auto?s=B70B9D4FCE32449ECAB3347A03008018&sec=1722790800&t=6ebd99033fa0f146d4fdecb1400b737b"
                  alt=""
                />
              </div>
              <div class="box">
                <div class="titleBox">
                  <div class="name">林师傅</div>
                  <div class="star">
                    <div class="iconfont icon-collection_fill"></div>
                    <div class="iconfont icon-collection_fill"></div>
                    <div class="iconfont icon-collection_fill"></div>
                    <div class="iconfont icon-collection_fill"></div>
                  </div>
                </div>
                <div class="textBox">
                  <div class="text">服务类型：安装，维修</div>
                  <div class="text">累计服务：2501次</div>
                </div>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import Kong from "../component/kong.vue";
import LoginZj from "../component/loginZj.vue";

export default {
  components: {
    LoginZj,
    Kong,
  },
  name: "",
  data() {
    return {
      searChTxt: "",
      typeOn: 0,
      typeList: ["零工列表"],
      areaOn: null,
      areaList: [
        {
          id: "",
          pid: 1142,
          code: 331021,
          name: "不限",
          car: "",
          is_sent: 1,
          is_delete: 0,
        },
        {
          id: 3723,
          pid: 1146,
          code: 0,
          name: "玉城",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
        },
        {
          id: 3724,
          pid: 1146,
          code: 0,
          name: "坎门",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
        },
        {
          id: 3725,
          pid: 1146,
          code: 0,
          name: "大麦屿",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
        },
        {
          id: 3726,
          pid: 1146,
          code: 0,
          name: "楚门",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
        },
        {
          id: 3727,
          pid: 1146,
          code: 0,
          name: "清港",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
        },
        {
          id: 3728,
          pid: 1146,
          code: 0,
          name: "龙溪",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
        },
        {
          id: 3729,
          pid: 1146,
          code: 0,
          name: "芦浦",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
        },
        {
          id: 3730,
          pid: 1146,
          code: 0,
          name: "沙门",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
        },
        {
          id: 3731,
          pid: 1146,
          code: 0,
          name: "干江",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
        },
        {
          id: 3732,
          pid: 1146,
          code: 0,
          name: "鸡山",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
        },
        {
          id: 3733,
          pid: 1146,
          code: 0,
          name: "海山",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
        },
      ],
      gzTypeOn: null,
      gzTypeList: [],
      judge: true,
      page: {
        pageNo: 1,
        pageSize: 10,
      },
      list: [],
      totalCount: 0,
      sxTypeOn: "",
      sxTypeList: [
        {
          name: "综合",
          type: "",
        },
        {
          name: "热门",
          type: "a.click desc",
        },
        {
          name: "发布时间",
          type: "a.modify_time desc",
        },
      ],
      sfJudge: true,
      sfPage: {
        pageNo: 1,
        pageSize: 10,
      },
      sfList: [],
      sfTotalCount: 0,
      zongPage: {},
    };
  },
  created() {
    // let areasList = window.localStorage.getItem("areasList");
    // if (areasList) {
    //   this.areasList = JSON.parse(areasList);
    // } else {
    //   this.areaGet();
    // }
    this.id = this.$route.query.id;
    this.zongPage.config_id = this.$route.query.id;
    this.typeGet();
    this.listGet();
    // this.sfListGet();
  },
  methods: {
    sxTypeClick(id) {
      this.sxTypeOn = id;
      this.zongPage.odb = id;
      if (this.typeOn == 0) {
        this.page.pageNo = 1;
        this.totalCount = 0;
        this.listGet();
      } else {
        this.sfPage.pageNo = 1;
        this.sfTotalCount = 0;
        this.sfListGet();
      }
    },
    listGet() {
      if (!this.judge) {
        return;
      }
      this.judge = false;
      this.$get("/nozzle/web/oddjob_gets", {
        ...this.page,
        ...this.zongPage,
      }).then((res) => {
        console.log(res);
        this.judge = true;
        if (this.totalCount == 0) {
          this.totalCount = res.totalCount;
        }
        if (res.data) {
          for (let i = 0; i < res.data.length; i++) {
            const e = res.data[i];
          }
          this.list = res.data;
        } else {
          this.list = [];
        }
      });
    },
    sfListGet() {
      if (!this.sfJudge) {
        return;
      }
      this.sfJudge = false;
      this.$get("/nozzle/web/member_odd_gets", {
        ...this.sfPage,
        ...this.zongPage,
      }).then((res) => {
        console.log(res);
        this.sfJudge = true;
        if (this.sfTotalCount == 0) {
          this.sfTotalCount = res.totalCount;
        }
        if (res.data) {
          for (let i = 0; i < res.data.length; i++) {
            const e = res.data[i];
            e.config_cn = e.config_cn.split(",");
            e.star = Math.floor(e.evaluatelength / 20);
          }
          this.sfList = res.data;
        } else {
          this.sfList = [];
        }
      });
    },
    pageOnChange(i) {
      this.page.pageNo = i;
      this.listGet();
    },
    sfPageOnChange() {
      this.sfPage.pageNo = i;
      this.sfListGet();
    },
    typeGet() {
      this.$get("/common/configuration_gets", {
        type: "linggong",
      }).then((res) => {
        console.log(res);
        this.gzTypeList = res.data;
        this.gzTypeList.unshift({
          name: "不限",
          id: "",
        });
        if (this.id) {
          for (let i = 0; i < this.gzTypeList.length; i++) {
            const e = this.gzTypeList[i];
            if (e.id == this.id) {
              this.gzTypeOn = e.id;
            }
          }
        }
      });
    },
    gzTypeClick(id) {
      this.gzTypeOn = id;
      this.zongPage.config_id = id;
      if (this.typeOn == 0) {
        this.page.pageNo = 1;
        this.totalCount = 0;
        this.listGet();
      } else {
        this.sfPage.pageNo = 1;
        this.sfTotalCount = 0;
        this.sfListGet();
      }
    },
    areaClick(id) {
      this.areaOn = id;
      this.zongPage.district = id;
      if (this.typeOn == 0) {
        this.page.pageNo = 1;
        this.totalCount = 0;
        this.listGet();
      } else {
        this.sfPage.pageNo = 1;
        this.sfTotalCount = 0;
        this.sfListGet();
      }
    },
    areaGet() {
      this.$get("/common/area_gets", {
        pageNo: -1,
      }).then((res) => {
        console.log(res);
        window.localStorage.setItem("areasList", JSON.stringify(res.data));
        this.areasList = res.data;
        // this.areasList.push(...res.data.slice().reverse());
        // console.log(this.areasList);
        // this.areaList = res.data[0].children[0].children;
        // this.areaList.unshift({
        //   name: "全" + res.data[0].children[0].name,
        //   id: res.data[0].children[0].id,
        // });
      });
    },
    gZjump(id) {
      // this.$router.push({
      //   path: "/ligGzCont",
      //   query: {
      //     id,
      //   },
      // });
      window.open("#/ligGzCont?id=" + id);
    },
    sFjump(id) {
      // this.$router.push({
      //   path: "/ligSfCont",
      //   query: {
      //     id,
      //   },
      // });
      window.open("#/ligSfCont?id=" + id);
    },
    typeClick(i) {
      this.typeOn = i;
      if (this.typeOn == 0) {
        this.page.pageNo = 1;
        this.totalCount = 0;
        this.listGet();
      } else {
        this.sfPage.pageNo = 1;
        this.sfTotalCount = 0;
        this.sfListGet();
      }
    },
    searchClick() {
      if (this.typeOn == 0) {
        this.page.name = this.searChTxt;
        this.page.pageNo = 1;
        this.totalCount = 0;
        this.listGet();
      } else {
        this.sfPage.name = this.searChTxt;
        this.sfPage.pageNo = 1;
        this.sfTotalCount = 0;
        this.sfListGet();
      }
    },
  },
  mounted() {},
  computed: {},
};
</script>
<style lang="less" scoped>
.serchBox {
  display: flex;
  justify-content: center;
  padding: 25px 55px;
  padding-right: 70px;
  padding-bottom: 5px;
  align-items: center;
  width: 1280px;
  margin: auto;
  box-sizing: border-box;
  .logoImg {
    width: 150px;
  }

  .inpBox {
    width: calc(100% - 70px);
    box-sizing: border-box;

    .inp {
      border: 2px solid #1a78ec;
      background-color: #fff;
      width: 100%;
      height: 50px;
      border-radius: 10px;
      display: flex;
      overflow: hidden;
      align-items: center;
      position: relative;

      .search {
        width: 65px;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;

        .iconfont {
          font-size: 24px;
          color: #999;
        }
      }

      .shu {
        width: 2px;
        height: 20px;
        background-color: #c9c9c9;
      }

      input {
        width: calc(100% - 67px);
        height: 100%;
        padding-left: 20px;
        box-sizing: border-box;
      }

      .searchBtn {
        cursor: pointer;
        width: 90px;
        height: calc(100% - 4px);
        position: absolute;
        right: 2px;
        top: 2px;
        background-color: #1a78ec;
        color: #fff;
        font-weight: 600;
        font-size: 16px;
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
.content {
  width: 1280px;
  margin: auto;
  overflow: hidden;
  padding-top: 20px;
  display: flex;
  .leftCont {
    overflow: hidden;
    width: calc(100% - 360px);
    background-color: #fff;
    box-sizing: border-box;
    padding: 20px;
    border-radius: 10px;
    .headBox {
      background-color: #fff;
      border-radius: 10px;
      .typeList {
        display: flex;
        height: 60px;
        font-size: 16px;
        margin-bottom: 10px;
        border-bottom: 2px solid #ebebeb;
        .type {
          box-sizing: border-box;
          height: 60px;
          width: 130px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .on {
          font-weight: 600;
          border-bottom: 2px solid #1677ff;
          color: #1677ff;
          position: relative;
          z-index: 9;
        }
      }
    }
    .chengzhihao {
      padding-bottom: 20px;
      border-bottom: 1px solid #ebebeb;
      display: flex;
      align-items: center;
      .text {
        margin-right: 20px;
        font-size: 18px;
        color: #666;
        cursor: pointer;
      }
      .on {
        font-weight: 600;
        color: #000;
      }
    }
    .pzBox {
      padding-top: 20px;
      border-bottom: 1px solid #ebebeb;
      height: 61px;
      overflow: hidden;
      position: relative;
      .modoBox {
        position: absolute;
        top: 16px;
        right: 0;
        display: flex;
        background-color: whitesmoke;
        padding: 5px 5px 5px 10px;
        border-radius: 5px;
        cursor: pointer;
        .name {
          font-size: 12px;
        }
        .iconfont {
          font-size: 12px;
        }
        .shang {
          animation: shang 0.5s both;
        }
        @keyframes shang {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(-180deg);
          }
        }
        .xia {
          animation: xia 0.5s both;
        }
        @keyframes xia {
          0% {
            transform: rotate(-180deg);
          }
          100% {
            transform: rotate(0deg);
          }
        }
      }
      .pzCnt {
        display: flex;
        .name {
          font-weight: 600;
          width: 120px;
        }
        .boxs {
          width: calc(100% - 120px);
          overflow: hidden;
          .box {
            float: left;
            margin-right: 25px;
            margin-bottom: 15px;
            color: #666;
            cursor: pointer;
          }
          .on {
            color: #1677ff;
          }
        }
      }
    }
    .pzBoxh {
      height: auto;
    }
    .sxCont {
      padding-top: 20px;
      display: flex;
      align-items: center;
      font-size: 16px;
      position: relative;
      border-bottom: 1px solid #ebebeb;
      padding-bottom: 20px;
      .text {
        margin-right: 25px;
        cursor: pointer;
      }
      .text:hover {
        color: #f66;
      }
      .jgBox {
        display: flex;
        align-items: center;
        cursor: pointer;
        height: 30px;
        margin-right: 25px;
      }
      .on {
        color: #f66;
      }
      .kBox {
        position: absolute;
        top: 50px;
        left: 90px;
        box-shadow: 0 0 4px 2px #ebebeb;
        border-radius: 5px;
        font-size: 14px;
        background-color: #fff;
        z-index: 99;
        .name {
          padding: 10px;
          border-bottom: 1px solid #ebebeb;
          cursor: pointer;
        }
        .name:hover {
          color: #f66;
        }
        .name:last-child {
          border-bottom: none;
        }
      }
      .inpBox {
        display: flex;
        align-items: center;
        .inp {
          width: 80px;
          border-radius: 5px;
          border: 1px solid #cfcfcf;
          height: 35px;
          overflow: hidden;
          box-sizing: border-box;
          input {
            width: 100%;
            height: 100%;
            padding-left: 8px;
            box-sizing: border-box;
            font-size: 14px;
          }
        }
        .hen {
          width: 5px;
          height: 1px;
          background-color: #9c9c9c;
          margin: 0 5px;
        }
        .serveBtn {
          font-size: 14px;
          margin-left: 10px;
          width: 60px;
          border-radius: 5px;
          height: 35px;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: rgb(30, 135, 233);
          color: #fff;
          cursor: pointer;
        }
      }
    }
    .lgBox {
      margin-top: 15px;
      .cont {
        cursor: pointer;
        margin-right: 15px;
        border-radius: 5px;
        background-color: #fff;
        margin-bottom: 15px;
        border-bottom: 1px solid #ebebeb;
        padding-bottom: 15px;
        .titBox {
          display: flex;
          align-items: center;
          justify-content: space-between;
          .name {
            font-weight: 600;
            font-size: 16px;
          }
          .address {
            color: #9c9c9c;
          }
        }
        .moneyBox {
          display: flex;
          align-items: center;
          margin-top: 8px;
          font-size: 16px;
          color: #ec3d07;
          font-weight: 600;
          .name {
            margin-right: 20px;
          }
        }
        .textBox {
          display: flex;
          margin-top: 5px;
          .text {
            width: 50%;
          }
        }
      }
    }
    .list {
      .li {
        padding-top: 15px;
        display: flex;
        border-bottom: 1px solid #ebebeb;
        padding-bottom: 15px;
        .img {
          width: 80px;
          height: 80px;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 50%;
          }
        }
        .cont {
          width: calc(100% - 80px);
          padding-left: 30px;
          box-sizing: border-box;
          .titleBox {
            display: flex;
            align-items: center;
            margin-bottom: 10px;
            .name {
              font-weight: 600;
              font-size: 20px;
              margin-right: 10px;
              cursor: pointer;
            }
            .star {
              display: flex;
              align-items: center;
              .iconfont {
                color: #ee0707;
                font-size: 20px;
                margin-right: 2px;
              }
            }
          }
          .box {
            display: flex;
            .wzList {
              width: calc(100% - 280px);
              .wzLi {
                margin-bottom: 5px;
                display: flex;
                .name {
                  width: 70px;
                  color: #666;
                  line-height: 150%;
                }
                .wzBox {
                  display: flex;
                  align-items: center;
                  width: calc(100% - 70px);
                  .txt {
                    color: #1677ff;
                    border: 1px solid #1677ff;
                    font-size: 12px;
                    border-radius: 5px;
                    padding: 3px 8px;
                    margin-right: 10px;
                  }
                }
                .texts {
                  width: calc(100% - 70px);
                  line-height: 150%;
                  color: #333;
                }
              }
              .disc {
                align-items: center;
              }
            }
            .fwBox {
              width: 120px;
              text-align: center;
              .text {
                font-size: 12px;
              }
              .name {
                font-size: 24px;
                font-weight: 600;
              }
            }
          }
        }
      }
    }
  }
  .rightCont {
    width: 360px;
    padding-left: 15px;
    .cont {
      background-color: #fff;
      border-radius: 10px;
      margin-bottom: 10px;
      .contHead {
        padding: 15px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #ebebeb;
        .name {
          font-weight: 600;
        }
        .iconfont {
          font-size: 14px;
          color: #9c9c9c;
        }
      }
      .contList {
        padding: 15px;
        .li {
          padding-bottom: 15px;
        }
        .li:last-child {
          padding-bottom: 0;
        }
      }
      .renList {
        .renLi {
          display: flex;
          padding: 15px;
          padding-bottom: 0;
          .img {
            width: 80px;
            height: 80px;
            img {
              width: 100%;
              height: 100%;
              border-radius: 5px;
              object-fit: cover;
            }
          }
          .box {
            width: calc(100% - 80px);
            padding-left: 15px;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .titleBox {
              display: flex;
              align-items: center;
              margin-bottom: 10px;
              .name {
                font-weight: 600;
                font-size: 15px;
                margin-right: 10px;
              }
              .star {
                display: flex;
                align-items: center;
                .iconfont {
                  color: #ee0707;
                  margin-right: 2px;
                }
              }
            }
            .textBox {
              .text {
                font-size: 13px;
                color: #666;
                margin-top: 5px;
              }
            }
          }
        }
        .renLi:last-child {
          padding-bottom: 15px;
        }
      }
    }
  }
}
</style>
